exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".links[data-v-02ccf0d3]{margin-left:14px}.bold[data-v-02ccf0d3]{font-weight:700}.link[data-v-02ccf0d3]{font-weight:700;color:#494298}.order_add[data-v-02ccf0d3]{font-size:14px;line-height:1.4;font-weight:700;color:rgba(0,0,0,.85)}.file[data-v-02ccf0d3]{margin-bottom:10px}.files[data-v-02ccf0d3]{display:-ms-flexbox;display:flex;gap:10px}.activity-order[data-v-02ccf0d3],.order_text[data-v-02ccf0d3]{font-size:14px;color:rgba(0,0,0,.85);line-height:1.4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-02ccf0d3","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ordersProcessForms/event/components/RequestRequirements.vue
// module id = 20638204c91c91b34532
// module chunks = 6